import { useTranslation } from "react-i18next";

import baiproReport from "Assets/images/enviroment/ReporteSostenibilidad.jpg";
import arrowBtn from "Assets/icons/arrow_left.svg";
import dossier from "Assets/files/Reporte-de-sostenibilidad-2025-BAIPRO.pdf";
import { trackEvent } from "Services/Analytics/trackEvent";
import "../Pages.scss";
import "./Enviroment.scss";

const ReportSection = () => {
  const { t } = useTranslation();

  const downloadEnviromentReport = () => {
    trackEvent("report_download");

    const link = document.createElement("a");
    link.href = dossier;
    link.download = t("enviroment.report.fileName");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section className="section-half-image section-report">
      <img
        src={baiproReport}
        width={1920}
        height={1080}
        loading="lazy"
        alt="baipro report"
        className="image"
      />
      <div className="content">
        <h2 className="title title-sky">{t(`enviroment.report.title`)}</h2>
        <p className="description">
          {t(`enviroment.report.text1`)}
          <br />
          <br />
          {t(`enviroment.report.text2`)}
        </p>
        <button
          className="button"
          aria-label={t(`enviroment.report.button`)}
          onClick={downloadEnviromentReport}
        >
          <img src={arrowBtn} width={24} height={24} alt="arrow rigth" />
          {t(`enviroment.report.button`)}
        </button>
        <div className="documents-container">
          <h3 className="hc-title">
            {t(`enviroment.report.carbonFootprintReduction`)}
          </h3>
          <article className="document">
            <div className="doc-container ">
              <span className="doc-title green">2024</span>
              <span className="doc-title green">
                48,36 tnCO
                <span style={{ fontSize: "0.7em", verticalAlign: "sub" }}>
                  2
                </span>
                eq
              </span>
            </div>

            <hr />
          </article>
          <article className="document">
            <div className="doc-container">
              <span className="doc-title black">
                2023
                <span style={{ display: "block", fontSize: "0.6em" }}>
                  {t(`enviroment.report.reduction2Subtitle`)}
                </span>
              </span>
              <span className="doc-title black">
                59,89 tnCO
                <span style={{ fontSize: "0.7em", verticalAlign: "sub" }}>
                  2
                </span>
                eq
              </span>
            </div>
            <hr />
          </article>
          <article className="document ">
            <div className="doc-container lightGreen">
              <span className="doc-title blackGreen">
                {t(`enviroment.report.totalReduction`)}
              </span>
              <span className="doc-title blackGreen">
                11,53 tnCO
                <span style={{ fontSize: "0.7em", verticalAlign: "sub" }}>
                  2
                </span>
                eq
              </span>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default ReportSection;
